export default __webpack_public_path__ + "static/k12-section-5-img-3d262a277f60388211622b8178d84c0a.png";